import '../style/modals/modalForm.css';

const ModalForm = ({
    isOpen,
    onClose,
    onSubmit,
    title,
    fields,
    children,
    size = 'medium',        // 'small', 'medium', 'large', 'fullscreen'
    showCloseButton = true,
    footer,
    className = ''          // Para agregar clases adicionales como 'stacked'
}) => {
    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit && fields) {
            const formData = {};
            fields.forEach((field) => {
                formData[field.name] = e.target[field.name].value;
            });
            onSubmit(formData);
        }
    };

    const sizeClasses = {
        small: 'modal-small',
        medium: 'modal-medium',
        large: 'modal-large',
        fullscreen: 'modal-fullscreen'
    }[size] || 'modal-medium';

    return (
        <div className={`modal-overlay ${className}`} onClick={onClose}>
            <div
                className={`modal-container ${sizeClasses}`}
                onClick={e => e.stopPropagation()}
            >
                <div className="modal-header">
                    <h2>{title}</h2>
                    {showCloseButton && (
                        <button
                            className="modal-close-btn"
                            onClick={onClose}
                            aria-label="Cerrar"
                        >
                            &times;
                        </button>
                    )}
                </div>

                <div className="modal-body">
                    {/* Si hay fields, renderizar formulario (modo antiguo) */}
                    {fields && fields.length > 0 ? (
                        <form onSubmit={handleSubmit}>
                            {fields.map((field, index) => (
                                <div key={index} className="form-group">
                                    {field.type === 'error-message' ? (
                                        <div className="form-error-message">
                                            ⚠️ {field.message}
                                        </div>
                                    ) : (
                                        <>
                                            <label htmlFor={field.name}>{field.label}</label>
                                            {field.type === 'select' ? (
                                                <div className="form-select-with-button">
                                                    <select
                                                        id={field.name}
                                                        name={field.name}
                                                        required={field.required || false}
                                                        defaultValue=""
                                                        disabled={field.disabled || false}
                                                        onChange={(e) => field.onChange && field.onChange(e.target.value)}
                                                        className="form-select-input"
                                                    >
                                                        <option value="" disabled>Selecciona una opción</option>
                                                        {field.options && field.options.map(opt => (
                                                            <option key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {field.onAddNew && (
                                                        <button
                                                            type="button"
                                                            onClick={field.onAddNew}
                                                            className="add-inline-btn"
                                                            title={field.addButtonTitle || 'Agregar nuevo'}
                                                        >
                                                            +
                                                        </button>
                                                    )}
                                                </div>
                                            ) : field.type === 'textarea' ? (
                                                <textarea
                                                    id={field.name}
                                                    name={field.name}
                                                    placeholder={field.placeholder || ''}
                                                    required={field.required || false}
                                                    rows={field.rows || 3}
                                                />
                                            ) : (
                                                <input
                                                    type={field.type || 'text'}
                                                    id={field.name}
                                                    name={field.name}
                                                    placeholder={field.placeholder || ''}
                                                    required={field.required || false}
                                                    defaultValue={field.defaultValue || ''}
                                                />
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}

                            {/* Botones del formulario */}
                            {!footer && (
                                <div className="modal-actions">
                                    <button type="button" onClick={onClose} className="cancel-btn">
                                        Cancelar
                                    </button>
                                    <button type="submit" className="submit-btn">
                                        Añadir
                                    </button>
                                </div>
                            )}
                        </form>
                    ) : (
                        /* Si hay children, renderizar contenido personalizado */
                        children
                    )}
                </div>

                {footer && (
                    <div className="modal-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ModalForm;